<div class="mds">
  <div class="holder">
    <div class="message">403 Forbidden</div>
    <div style="font-size: 1.5rem; text-align: center; padding-bottom: 50px">You do not have access to visit this page</div>
    <div>
      <h1>Advanced Equipment Maintainence System</h1>
    </div>
  </div>
</div>
